import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=02f9c8de&"
import script from "./Trash.vue?vue&type=script&lang=ts&"
export * from "./Trash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports